import { GridFilterModel } from '@mui/x-data-grid';

export function parseFilterModel(filterModel: GridFilterModel) {
    const conditions: unknown[] = [];
    filterModel.items.forEach((item) => {
        const field = item.field;
        const operator = item.operator;
        const value = item.value;

        switch (field) {
            case 'className':
                conditions.push({
                    className: {
                        [operator]: value,
                    },
                });
                break;
        }
    });

    return conditions;
}
